import {Tooltip} from 'react-bootstrap'

function popover(content: string) {
  return <Tooltip>{content}</Tooltip>
}

export default popover
